var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/require-default-props */
import React from 'react';
import classNames from 'classnames';
import './TextStyles.scss';
/**
 * Text component following the Quimby design system typography
 *
 * @example
 * ```tsx
 * <Text variant="xx-large" as="h1">Page Title</Text>
 * <Text variant="body">Regular body text</Text>
 * <Text variant="link" as="a" href="#">Link text</Text>
 * ```
 */
export function Text(_a) {
    var { as, variant = 'body', children, className } = _a, props = __rest(_a, ["as", "variant", "children", "className"]);
    const Component = as || 'span';
    const variantClass = `qmb-ui-text--${variant}`;
    return (React.createElement(Component, Object.assign({ className: classNames('qmb-ui-text', variantClass, className) }, props), children));
}
